export default "__VITE_ASSET__LmJljsdg__"